import {StoreHelper} from './store';
import {ApiHelper} from './api';

let storeHelper: StoreHelper = new StoreHelper();
let apiHelper: ApiHelper = new ApiHelper(storeHelper);

export class BasePage {
  app = this.sel('.app');
  templates = this.sel('.templates');
  loading = this.sel('.svg-loading', this.templates);

  storeHelper = storeHelper;
  apiHelper = apiHelper;

  setPage(element) {
    this.app.innerHTML = '';
    this.app.appendChild(element);
  }

  sel(sel: string, par?) {
    if (par) {
      return par.querySelector(sel);
    }
    return document.querySelector(sel);
  }

  ac(el, cl) {
    el.classList.add(cl);
  }

  rc(el, cl) {
    el.classList.remove(cl);
  }

  addLoading(sel, par?) {
    this.sel(sel, par).appendChild(this.loading.cloneNode(true));
  }

  addEvent(el, ev, cb) {
    el.addEventListener(ev, cb);
  }
}
